module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/423.27dd13d5.png";